<template>
<div class="school-channel__intro--content" @touchmove.prevent>
    <i class="school-channel__close-icon" @click="handleClick"></i>
    <ul ref="protocolContent" class="school-channel__intro--main">
        <li class="school-channel__intro--item" v-for="(item, index) in rules" :key="'rule'+index">
            <i>{{index + 1}}</i><span>{{item}}</span>
        </li>
    </ul>
</div>
</template>

<script>
import BScroll from "better-scroll";
export default {
    name: "protocol",
    data() {
        return {
            bScroll: null,
            rules: [
                '完善孩子姓名、学校、联系手机号即可领取5份少儿思维大礼包',
                '稍后会有您的专属课程顾问与您沟通，为您的孩子调试设备并安排直播课程',
                '下载掌门少儿电脑版或pad版客户端，即可获得5节AI录播课和学习乐园的使用权',
                '下载掌门少儿APP，即可观看家长课堂，并可随时随地查看孩子学习情况',
                '购买正式课后，立即赠送实物教具大礼盒，提高孩子的动脑动手能力'
            ]
        };
    },
    props: {
        showIntro: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        showProtocol(val) {
            if (val) {
                this.$nextTick(() => {
                    this.bScroll = this.$refs.protocolContent ?
                        new BScroll(this.$refs.protocolContent, {
                            click: true
                        }) :
                        null;
                });
            }
        }
    },
    methods: {
        handleClick() {
            this.$emit("update:showIntro", false);
        }
    }
};
</script>

<style lang="scss" scoped>
// @import "./../../styles/mixin.scss";
.school-channel {
    &__intro {
        &--content {
            position: relative;
            background: url("https://web-data.zmlearn.com/image/jY5k6FHoj1uUBFUBu8PNyb/rule.png") top center no-repeat;
            background-size: 100%;
            background-color: #fff;
            border-radius: px2rem(48);
        }
        &--main{
            padding: px2rem(136) px2rem(37) 0 px2rem(43);
            text-align: left;
            margin: px2rem(10) 0;
            font-size: px2rem(30);
            overflow: scroll;

        }
        &--item {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;
            font-size: 0;
            margin-bottom: px2rem(24);
            i {
                flex-shrink: 0;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-style: normal;
                width: px2rem(30);
                height: px2rem(30);
                margin: px2rem(7) px2rem(12) 0 0;
                background: #FF8642;
                border-radius: 50%;
                font-size: px2rem(20);
                font-family: Yuanti SC;
                font-weight: bold;
                color: #FFFFFF;
            }
            span {
                font-size: px2rem(26);
                font-family: Yuanti SC;
                font-weight: 400;
                color: #635C5A;
                line-height: px2rem(46);
            }
        }
    }
    &__close-icon {
        position: absolute;
        width: px2rem(50);
        height: px2rem(50);
        bottom: px2rem(-80);
        left: 50%;
        transform: translateX(-50%);
        background-color: #cccccc;
        background: url("https://web-data.zmlearn.com/image/cAqihkAcX7nWpp7aMFfzzw/close.png") no-repeat center;
        background-size: 100%;
    }
}


</style>
